package com.mps.asc_app.data.places

import com.mps.asc_app.data.places.model.AddressSuggestion
import kotlinx.coroutines.await

private external val google: dynamic

class PlacesRepositoryJsImpl : PlacesRepository {

    override suspend fun autocomplete(query: String): List<AddressSuggestion> {
        val q = query.trim()
        if (q.length < 3) return emptyList()

        return try {
            // Load the modern Places library (required for AutocompleteSuggestion)
            val placesLib = google.maps.importLibrary("places")
                .unsafeCast<kotlin.js.Promise<dynamic>>()
                .await()

            val AutocompleteSuggestion = placesLib.AutocompleteSuggestion
            val AutocompleteSessionToken = placesLib.AutocompleteSessionToken

            // Session token is recommended to group user keystrokes
            val sessionToken = js("new AutocompleteSessionToken()")

            val request = js("{}")
            request.input = q
            request.sessionToken = sessionToken
            request.language = "de"

            // New API: fetchAutocompleteSuggestions
            val response = AutocompleteSuggestion.fetchAutocompleteSuggestions(request)
                .unsafeCast<kotlin.js.Promise<dynamic>>()
                .await()

            val suggestions = response.suggestions as? Array<dynamic> ?: emptyArray()

            val result = mutableListOf<AddressSuggestion>()
            for (s in suggestions) {
                val prediction = s?.placePrediction

                // Property names differ from legacy predictions; keep it defensive.
                val placeId = (prediction?.placeId ?: prediction?.place_id) as? String

                // Prefer the main text field if present; fall back to toString.
                val fullText = when (val t = prediction?.text) {
                    null -> null
                    else -> t.toString()
                } ?: (prediction?.description as? String)

                if (!placeId.isNullOrBlank() && !fullText.isNullOrBlank()) {
                    result += AddressSuggestion(placeId = placeId, fullText = fullText)
                }
            }

            result
        } catch (_: dynamic) {
            // If Places isn't available / misconfigured, fail gracefully.
            emptyList()
        }
    }
}